











































import { Vue, Component } from 'vue-property-decorator';
import ChatSettingForm from './chat-setting-form.vue';
import EdiForm from './edi-form.vue';
import EdiLinkForm from './edi-link-form.vue';
import { createTypeMapping } from './util';
import { IChatFormData, operateRobotStatus, fetchRobotInfo } from '@/api/rg';
export interface IChatConfig {
    rgId: number;
    isActive: boolean;
    userType: 'SUPER_ADMIN' | 'RG_ADMIN';
    robotProxyList: IChatFormData[];
}

const CREATE_TYPE = {
    EDI: 'createEDI',
    EDI_LINK: 'linkEDI',
    FRIDAY_LINK: 'linkFriday',
    FRIDAY_NEW: 'createFriday'
};

@Component({
    components: {
        ChatSettingForm,
        EdiForm,
        EdiLinkForm
    }
})
export default class extends Vue {
    isEnableRobot = false;
    createType = 'createEDI';
    isLoaded = false;
    isError = false;
    errorMessage = '';
    userType = '';
    isShowEDIType = false;
    isShowFridayType = false;

    radioOptions: any[] = [];

    private _rgId: number | undefined;
    private robotConfigs: any[] = [];
    private robotConfigsFriday: any[] = [];
    private robotConfigsEDI: any[] = [];
    private robotConfigsEDILink: any[];

    private get isFridayType() {
        return this.createType === CREATE_TYPE.FRIDAY_LINK || this.createType === CREATE_TYPE.FRIDAY_NEW;
    }

    private get isEDIType() {
        return this.createType === CREATE_TYPE.EDI;
    }

    async created() {
        this._rgId = this._parseRgId();
        await this._fetchRobotInfo();
    }

    /**
     * 计算灰度展示逻辑
     */
    private calcGreyRange(greyRange: any) {
        /**
         * 计算类型展示
         */
        if (greyRange && greyRange.length > 0) {
            const hasEDI = greyRange.some(item => item.llmPlatform === 'EDI');
            if (hasEDI) {
                this.isShowEDIType = true;
                this.radioOptions.push({
                    value: CREATE_TYPE.EDI,
                    label: '申请TT智能问答机器人'
                });
            }

            const hasEDILink = greyRange.some(item => item.llmPlatform === 'EDI' && item.robotType === 'SMART_LINK');
            if (hasEDILink) {
                this.isShowEDIType = true;
                this.radioOptions.push({
                    value: CREATE_TYPE.EDI_LINK,
                    label: '绑定EDI智能问答机器人'
                });
            }

            const hasFridayNew = greyRange.some(item => item.llmPlatform === 'FRIDAY' && item.robotType === 'SMART_NEW');
            if (hasFridayNew) {
                this.isShowFridayType = true;
                this.radioOptions.push({
                    value: CREATE_TYPE.FRIDAY_NEW,
                    label: '申请TT智能问答机器人(Friday版)'
                });
            }

            const hasFridayLink = greyRange.some(item => item.llmPlatform === 'FRIDAY' && item.robotType === 'SMART_LINK');
            if (hasFridayLink) {
                this.isShowFridayType = true;
                this.radioOptions.push({
                    value: CREATE_TYPE.FRIDAY_LINK,
                    label: '绑定智能问答机器人(Friday)'
                });
            }
        }

        if (!this.robotConfigs || this.robotConfigs.length === 0) {
            if (this.isShowEDIType) {
                this.createType = CREATE_TYPE.EDI;
            } else if (this.isShowFridayType) {
                this.createType = CREATE_TYPE.FRIDAY_NEW;
            }

            return;
        }

        /**
         * 若有激活的机器人，直接使用激活的机器人
         * 没有激活的 机器人， 按照时间排序
         */
        let activeRobot = this.robotConfigs.find(item => {
            return item.isActive === true;
        });

        if (!activeRobot) {
            activeRobot = this.robotConfigs[0];
        }
        this.createType = this.getCreateTypeFromRobotType(activeRobot);
    }

    getCreateTypeFromRobotType(activeRobot: IChatFormData) {
        if (activeRobot.llmPlatform === 'FRIDAY') {
            if (activeRobot.type === 'SMART_NEW') {
                return CREATE_TYPE.FRIDAY_NEW;
            }
            return CREATE_TYPE.FRIDAY_LINK;
        } else {
            if (activeRobot.type === 'SMART_LINK') {
                return CREATE_TYPE.EDI_LINK;
            }
            return CREATE_TYPE.EDI;
        }
    }

    async _fetchRobotInfo() {
        try {
            const { data, code, message } = await fetchRobotInfo(this._rgId);
            if (code === 200) {
                this.isEnableRobot = data.isActive;
                this.robotConfigs = data.robotProxyList || [];
                this.robotConfigsFriday = this.robotConfigs.filter(item => item.llmPlatform === 'FRIDAY').sort((b, a) => a.updateAt - b.updateAt);
                this.robotConfigsEDI = this.robotConfigs.filter(item => item.llmPlatform === 'EDI' && item.type === 'SMART_NEW');
                this.robotConfigsEDILink = this.robotConfigs.filter(item => item.llmPlatform === 'EDI' && item.type === 'SMART_LINK');

                this.calcGreyRange(data.greyRange);

                this.userType = data.userType;
            } else if (code === 11020) {
                this.isError = true;
                this.errorMessage = '权限不足, 请联系 TT 管理员';
            } else {
                this.isError = true;
                this.errorMessage = `发生错误, 请联系 TT 管理员: ${message}`;
            }
        } catch (_err) {
            this.isError = true;
            this.errorMessage = `发生错误(E), 请联系 TT 管理员:${_err}`;
        } finally {
            this.isLoaded = true;
        }
    }

    private _parseRgId(): number {
        return parseInt(this.$route.query.rgId as string, 10);
    }

    handleCreateTypeChange(val) {
        console.log('handleCreateTypeChange', val);
        this.createType = val;
    }

    async handleRobotEnable(value: boolean) {
        const payload = {
            status: value ? 'ON' : 'OFF'
        };

        const { code, message } = await operateRobotStatus(this._rgId, payload);

        if (code === 11048) {
            this.isEnableRobot = !value;
            this.$mtd.message({
                message: message,
                type: 'error'
            });
        } else {
            this.isEnableRobot = value;
        }
    }
}
